module.exports = __webpack_public_path__ + "img/homerow-tutorial.6f65b05b.gif";